import { z } from 'zod';
import { PUMP_SIDES } from '../constants.ts';

export const pumpSideSchema = z.enum(PUMP_SIDES);

export const pumpStartSchema = z.object({
  side: pumpSideSchema.optional(),
  started_at: z.number().int().optional(),
});

export const pumpStopSchema = z.object({
  /** Target session ID. When provided, the stop affects this specific
   *  pump regardless of who started it (so a partner can end the other
   *  partner's session). When absent, the current user's own in-progress
   *  pump is stopped. */
  id: z.string().optional(),
  side: pumpSideSchema.optional(),
  yield_ml: z.number().int().min(0).max(2000).optional(),
  yield_left_ml: z.number().int().min(0).max(2000).optional(),
  yield_right_ml: z.number().int().min(0).max(2000).optional(),
  ended_at: z.number().int().optional(),
});

export const pumpCreateSchema = z.object({
  started_at: z.number().int(),
  ended_at: z.number().int().nullable().optional(),
  side: pumpSideSchema.nullable().optional(),
  yield_ml: z.number().int().min(0).max(2000).nullable().optional(),
  yield_left_ml: z.number().int().min(0).max(2000).nullable().optional(),
  yield_right_ml: z.number().int().min(0).max(2000).nullable().optional(),
  notes: z.string().max(2000).nullable().optional(),
});

export const pumpPatchSchema = pumpCreateSchema.partial();

export type PumpStartInput = z.infer<typeof pumpStartSchema>;
export type PumpStopInput = z.infer<typeof pumpStopSchema>;
export type PumpCreateInput = z.infer<typeof pumpCreateSchema>;
export type PumpPatchInput = z.infer<typeof pumpPatchSchema>;
